import { Utils } from 'src/modules/utils/shared/utils';
import { DatabaseUserGroupAttribute } from './database-user-group-attribute.model';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Strings } from 'src/modules/utils/shared/strings';

export class DatabaseUserGroup {
    id = 0;
    name = "";
    sortName = "";

    attributes: DatabaseUserGroupAttribute[] = [];

    getStringRepresentation(): string {
        return this.name;
    }

    getAttributeValue(name: string): string {
        let attrib = this.attributes.find(a => a.key == name);
        if (attrib == null) {
            throw new Error("Das Benutzergruppen-Attribut '" + name + "' wurde nicht gefunden. Verfügbare Attribute: " + Arrays.itemsToString(this.attributes, ", ", a => a.key));
        }
        return attrib.value;
    }

    getAttributeValueBool(name: string): boolean {
        return Utils.toBool(this.getAttributeValue(name));
    }

    getAttributeValueNumber(name: string): number {
        return Utils.toNumber(this.getAttributeValue(name));
    }

    getSortName(): string {
        return Strings.def(this.sortName, this.name);
    }
}
